export type ScanType = 'ASN' | 'LPN' | 'TN'

export type FlowType = 'Recepción' | 'Devoluciones'

export type UnknownOption = 'Prioridad' | 'SKU/EAN' | 'Proveedor' | 'Origen'

export const FLOW_TYPE_ID: Record<FlowType, number> = {
  'Recepción': 1,
  'Devoluciones': 2
}

// Resumen de una ASN relacioanada, generada por la división de una devolución de
// marca mixta (INT/EXT). Ambas comparten el mismo preInbound.
export interface RelatedAsnSummary {
  asnId: number
  asnNumber: string
  asnStateId: number
  asnStateName: string
}

export interface AsnLocateResult {
  asnId: number
  asnNumber: string
  supplierName: string
  supplierOriginName: string
  skuQty: number
  unitsQty: number
  brandName: string
  productOriginId: number
  withLpn: boolean
  priority: number
  /** Solo viene cuando la devolución se divide en más de una ASN */
  relatedAsns?: RelatedAsnSummary[]
}

export interface LpnInfo {
  asnId: number
  lpn: string
  lpnStateId: number
  userId?: number
}

export interface AsnReceptionBatchHistoryDto {
  batchId: number
  batchNumber: string
  expirationDate?: string | null
  qty: number
}

export interface AsnReceptionPositionHistoryDto {
  positionName: string
  qty: number
  batchList: AsnReceptionBatchHistoryDto[]
}

export interface AsnReceptionSkuHistoryDto {
  skuId: number
  sku: string
  qty: number
  excessQty: number
  positionList: AsnReceptionPositionHistoryDto[]
}

// Respuesta de CheckPosition: atributos de la posición + quién la ocupa actualmente en BD
// (currentSkuId/currentBatchId vienen null si la posición está limpia, o si el atributo
// correspondiente - monoSku/monoBatch - no está habilitado).
export interface AsnReceptionPositionInfoDto {
  positionId: number
  typePositionId: number
  maxCapacity: number
  monoBatch: boolean
  monoSku: boolean
  currentStockQty: number
  currentSkuId: number | null
  currentSku: string | null
  currentBatchId: number | null
  currentBatchNumber: string | null
}

export interface AsnLocateState {
  scanType: ScanType
  scanValue: string
  results: AsnLocateResult[]
  isLoading: boolean
  lpnList: LpnInfo[]
  lpnAsnId: number | null
  selectedLpn: string | null
  selectedResult: AsnLocateResult | null
  hideBackButton?: boolean
  stepTitle?: string
  defaultFlowType?: FlowType
}

export interface WorkOrderReceptionDetailInfoDto {
  lpn: string
  skuId: number
  sku: string
  ean: string
  skuName: string
  batchId?: number
  realQty: number
  controlledQty?: number
  locatedQty: number
}

export interface WorkOrderReceptionDunInfoDto {
  stockKeepingUnitId: number
  dun: string
  quantity: number
  typePackageId?: number
  typePackageName?: string
}

export interface WorkOrderReceptionInfoDto {
  workOrderId: number
  asnId: number
  asnNumber: string
  brandName: string
  productOriginId: number
  asnCreatedDate: string
  warehouseId: number
  typeStorageId?: number
  typeOperationId?: number
  isReserveReception: boolean
  isPreSaleReception: boolean
  asnStateId: number
  workOrderDetails: WorkOrderReceptionDetailInfoDto[]
  workOrderDuns: WorkOrderReceptionDunInfoDto[]
  /** Solo viene cuando la devolución se divide en más de una ASN */
  relatedAsns?: RelatedAsnSummary[]
  /** Pedido que originó la devolución. Se usa para nombrarlo en el aviso de ASN relacionadas */
  externalOrderId?: string
}

export enum eStepAsnLocate{
  ScanStep = 0, 
  ResultsStep = 1,
  UnknownIdStep = 2,
  LpnStep = 3,
  LocateStepV2 = 4
}
